module.exports = __webpack_public_path__ + "static/img/hw.26c15f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/hw.png
// module id = BCq/
// module chunks = 13